import { connect } from 'react-redux';
import { AgreementContainer as Component } from './AgreementContainer';

/*
 * TODO удалить этот код когда обновится react-redux@6 до react-redux@7 во frontend-mobile-website - https://jira.cian.tech/browse/AUD-1778
 * В react-redux@6 ещё не было useSelector и useDispatch, поэтому мы прокидываем их ручками.
 * После того как обновим старый мобсайт нужно использовать useSelector и useDispatch из react-redux,
 * а эти пропсы удалить вовсе. Прослойку connect больше ни для каких целей не используем, это временное решение.
 */

export function mapStateToProps(state) {
  return {
    useSelector: function useSelector(fn) {
      return fn(state);
    }
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    useDispatch: function useDispatch() {
      return dispatch;
    }
  };
}
export var AgreementContainer = connect(mapStateToProps, mapDispatchToProps)(Component);